import { Badge, ColorVariant } from '@makyoapp/makyo-ui'

import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import { useOrgsContext } from '@/context/OrgsContext'

export default function BillingSection() {
  const { currentOrg } = useCurrentOrgContext()
  const { recentApps } = useOrgsContext()

  const plan = recentApps.find((o) => o.org.id === currentOrg?.id)?.plan || {
    name: 'FREE',
    badgeColor: ColorVariant.Yellow,
  }

  return (
    <div className='bg-white dark:bg-slate-800/50 rounded-xl p-6 backdrop-blur-xs border border-slate-200/50 dark:border-slate-700/50 shadow-xs'>
      <div className='flex items-center justify-between mb-6'>
        <h2 className='text-lg font-medium text-slate-900 dark:text-white'>Billing</h2>
        <Badge color={plan?.badgeColor as ColorVariant} className='ml-2 text-xs'>
          {plan?.name}
        </Badge>
      </div>
      <div className='space-y-4'>
        <div className='text-sm'>
          <div className='font-medium text-slate-900 dark:text-white mb-2'>Plan</div>
          <div className='text-slate-600 dark:text-slate-400'>$29.99/Month or $699.99/year</div>
        </div>
        <div className='space-y-2'>
          <div className='text-sm'>
            <div className='font-medium text-slate-900 dark:text-white'>Last charge date</div>
            <div className='text-slate-600 dark:text-slate-400'>January 15, 2024</div>
          </div>
          <div className='text-sm'>
            <div className='font-medium text-slate-900 dark:text-white'>Next charge date</div>
            <div className='text-slate-600 dark:text-slate-400'>February 15, 2024</div>
          </div>
        </div>
        <div className='pt-2 space-y-3'>
          <button className='w-full p-3 bg-slate-100 dark:bg-slate-700/30 rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700/50 transition-all text-left text-slate-900 dark:text-white'>
            Change Plan
          </button>
          <button className='w-full p-3 bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-500/20 transition-all text-left'>
            Cancel Plan
          </button>
        </div>
      </div>
    </div>
  )
}
